import labels from "../../../utils/labels";
import StandardButton from "../../UI/buttons/StandardButton";
import ColouredRoundWrapper from "../../UI/wrappers/ColouredRoundWrapper";
import statusBarStyles from "../../../styles/statusBars.module.css";
import { ReactComponent as HandIcon } from "../../../assets/icons/hand.svg";
import { ReactComponent as UndoIconWhite } from "../../../assets/icons/undo_white.svg";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import DragAndDropService from "../../../service/dragAndDrop";
import { useEffect, useRef, useState } from "react";

const DragAndDropStatusBar = () => {
  const dispatch = useAppDispatch();
  // Tanja: update spinner to customSpinner
  const { showSpinner } = useAppSelector((state) => state.ganttChartSlice);
  const { activeSessionStatus } = useAppSelector(
    (state) => state.dragAndDropSlice,
  );
  const [enable, setEnable] = useState<boolean>(true);
  const undoButtonRef = useRef<HTMLButtonElement>(null);
  // Tracks whether the button held focus (e.g. keyboard activation) when disabled,
  // so it can be refocused once re-enabled without stealing focus in other cases.
  const shouldRestoreFocusRef = useRef(false);
  const undo = async () => {
    shouldRestoreFocusRef.current =
      document.activeElement === undoButtonRef.current;
    setEnable(false);
    await DragAndDropService.undo(dispatch);
    setEnable(true);
  };

  // The native `disabled` attribute blurs the button the instant it's applied, and
  // React only removes it on the next commit — so refocusing must happen in an effect
  // that runs after that commit, not synchronously inside `undo`.
  useEffect(() => {
    if (enable && shouldRestoreFocusRef.current) {
      shouldRestoreFocusRef.current = false;
      undoButtonRef.current?.focus();
    }
  }, [enable]);

  return (
    <ColouredRoundWrapper
      bgColor="var(--col-interaction-tertiary)"
      height="60px"
      classes={`${statusBarStyles.customPlanInfo} min-w-[261px]`}
    >
      <HandIcon />
      {showSpinner
        ? labels.calculatingTransportation
        : activeSessionStatus?.rulesBroken
          ? `${activeSessionStatus.rulesBroken}  ${labels.violations}`
          : `0 ${labels.violations}`}
      {activeSessionStatus?.canUndo && (
        <StandardButton
          ref={undoButtonRef}
          onClick={undo}
          variant="WHITE"
          disable={!enable}
          ariaLabel={labels.undo}
        >
          {labels.undo}
          <UndoIconWhite />
        </StandardButton>
      )}
    </ColouredRoundWrapper>
  );
};

export default DragAndDropStatusBar;
